import { Dispatch, SetStateAction, useEffect } from 'react';
import { Button, Snackbar, IconButton } from '@mui/material';
import { Close } from '@mui/icons-material';
import { SnackbarMessage } from './ManageUsers';
import { ManageUserAPI, Roles } from 'App';

type TypeProps = {
  snackPack: readonly SnackbarMessage[];
  setSnackPack: Dispatch<SetStateAction<readonly SnackbarMessage[]>>;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  messageInfo?: SnackbarMessage;
  setMessageInfo: Dispatch<SetStateAction<SnackbarMessage | undefined>>;
  handleRestoreUser: () => void;
  changedUser: ManageUserAPI | null;
  setChangedUser: Dispatch<SetStateAction<ManageUserAPI | null>>;
  isRoles: boolean;
  handleChangeRoles: (user: ManageUserAPI, roles: Roles[], restore?: boolean) => void;
};

export const UndoSnackbar = ({
  snackPack,
  setSnackPack,
  open,
  setOpen,
  messageInfo,
  setMessageInfo,
  changedUser,
  setChangedUser,
  handleRestoreUser,
  isRoles = false,
  handleChangeRoles,
}: TypeProps) => {
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setChangedUser(null);
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };

  useEffect(() => {
    if (snackPack.length && !messageInfo) {
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      setOpen(false);
    }
  }, [snackPack, messageInfo, open, setMessageInfo, setSnackPack, setOpen]);

  return (
    <Snackbar
      sx={{ top: '72px !important' }}
      key={messageInfo ? messageInfo.key : undefined}
      open={open}
      autoHideDuration={7000}
      onClose={handleClose}
      TransitionProps={{ onExited: handleExited }}
      message={messageInfo ? messageInfo.message : undefined}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      action={
        <>
          <Button
            color='secondary'
            size='small'
            onClick={(e) => {
              if (isRoles && changedUser) {
                handleChangeRoles(changedUser, changedUser.roles, true);
              } else {
                handleRestoreUser();
              }
              handleClose(e);
            }}
          >
            UNDO
          </Button>
          <IconButton aria-label='close' color='inherit' sx={{ p: 0.5 }} onClick={handleClose}>
            <Close />
          </IconButton>
        </>
      }
    />
  );
};
